module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"field-required":"Pflichtfeld","field-invalid-format":"Diese Nummer ist ungültig"},"en":{"field-required":"Required field","field-invalid-format":"This number is invalid"},"fr":{"field-required":"Champ obligatoire","field-invalid-format":"Ce numéro n\u0027est pas valide"},"it":{"field-required":"Campo obbligatorio","field-invalid-format":"Questo numero non è valido"}}')
  delete Component.options._Ctor
}
